import * as React from 'react'
import './index.scss'
import { connect } from "react-redux";
import { ActionType, CHAINTYPES, countListType, indexStatType, reducerStoreType, ROLES, selectWalletType } from "../../reducers/types";
import { Dispatch } from "redux";
import OverView from "./OverView";
import Cashier from "./Cashier";
import LatestOrders from "./LatestOrders";
import Stats from "./Stats";
import Grid from "@material-ui/core/Grid";

interface IProps {
  dispatch: Dispatch<ActionType<undefined>>,
  indexStat: indexStatType | undefined,
  currency?: string,
  chainType: CHAINTYPES,
  currentStore: number,
  role: ROLES,
  selectWallet: selectWalletType
}

class DashBoard extends React.Component<IProps, {}> {
  public render() {
    let { indexStat, currency } = this.props
    let tradeAmt = 0, tradeNum = 0, monthTradeAmt = 0, monthTradeNum = 0, countList: countListType[] = []
    if (indexStat) {
      tradeAmt = indexStat.tradeAmt
      tradeNum = indexStat.tradeNum
      monthTradeAmt = indexStat.monthTradeAmt
      monthTradeNum = indexStat.monthTradeNum
      countList = indexStat.countList
    }
    const superView = (this.props.chainType === CHAINTYPES.CHAIN_STORE &&
      this.props.currentStore === -1
      && this.props.role === ROLES.SUPER_ADMIN)
    return (
      <div className="dashBoard">
        <OverView tradeAmt={tradeAmt}
          tradeNum={tradeNum}
          countList={countList}
          tradeAmtMonth={monthTradeAmt}
          tradeNumMonth={monthTradeNum}
          currency={currency} />
        <Grid container spacing={2}>
          {superView ? <Stats /> :
            <Cashier />}
          <LatestOrders superView={superView} selectWallet={this.props.selectWallet} />
        </Grid>
      </div>
    );
  }
}

export default connect((state: reducerStoreType) => {
  return {
    indexStat: state.dashboard.indexStat,
    currency: state.app.userInfo ? state.app.userInfo.currency : '',
    chainType: state.merchant.merchantInfo.chainType,
    currentStore: state.app.currentStore,
    role: state.app.userInfo ? state.app.userInfo.role : ROLES.NONE,
    selectWallet: state.merchant.merchantInfo.selectWallet
  }
})(DashBoard)